export default {
  namespaced: true,
  state: {
    data: [],
  },
  mutations: {},
  actions: {},
};
